import * as yup from "yup"

export const validationSchema = yup.object().shape({
    mr_document_code: yup.string().label("Document type code").required().min(2).max(3),
    mr_document_name: yup.string().label("Document type name").required().max(100, "Must be 100 characters or less"),
    description: yup.string().optional()
})